module.exports = __webpack_public_path__ + "static/img/hatchback-indigo.1e0f776.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/hatchback-indigo.svg
// module id = rtaF
// module chunks = 74